var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panels",
    [
      _c(
        "v-expansion-panel",
        [
          _c("v-expansion-panel-header", [
            _c("h4", { staticClass: "cooperation__expansion-title" }, [
              _vm._v("Порядок действий"),
            ]),
          ]),
          _vm._v(" "),
          _c("v-expansion-panel-content", [
            _c("ol", { staticClass: "cooperation__expansion-list" }, [
              _c("li", { staticClass: "cooperation__expansion-item" }, [
                _vm._v("Регистрация на платформе "),
                _c(
                  "a",
                  { attrs: { href: "https://ul.su/", target: "_blank" } },
                  [_vm._v("https://ul.su/")]
                ),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "cooperation__expansion-item" }, [
                _vm._v(
                  'Поиск нашей организации ООО "Упаковка и Сервис" и ООО "Нова\n                    Ролл-стрейч" (входят в группу компаний Novaroll)\n                '
                ),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "cooperation__expansion-item" }, [
                _vm._v(
                  "Внимательное изучение требований для поставщиков услуг"
                ),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "cooperation__expansion-item" }, [
                _vm._v("Предоставление обязательного пакета документов"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "cooperation__expansion-item" }, [
                _vm._v(
                  "Готовность работать по нашему договору транспортной\n                    экспедиции\n                "
                ),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "cooperation__expansion-item" }, [
                _vm._v("Подача заявки на аккредитацию"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "cooperation__expansion-item" }, [
                _vm._v("Ожидание результата проверки документов"),
              ]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "cooperation__expansion-desc" }, [
              _vm._v(
                "О результатах аккредитации Вам будет известно в личном кабинете\n                на платформе «Умная Логистика»."
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }